
import React, { useState, useEffect } from 'react';
import {
	WifiOutlined,
} from '@ant-design/icons';
import Page from '../../components/page';
import * as Request from '../../common/request';
import './index.less';

const PageModel = props => {
	const [company, setCompany] = useState('');
	const [ equipmentList, setEquipmentList ] = useState([]);

	const getEquipmentList = async () => {
		const result = await Request.get({
			url: '/getmyequipment'
		});
		if (!result) return;
		console.log('---', result.data.equipmentList);
		setCompany(result.data.company || '');
		setEquipmentList(result.data.equipmentList || []);
	};
	useEffect(() => {
		//获取当前微信绑定的店铺信息
		getEquipmentList();
	}, [ 123 ]);

	return (
		<Page {...{ page: 'home', showFooter: true, title: '在线设备管理系统' }} {...props}>
			<section className="home-container" style={{ minHeight: window.innerHeight - 50 }}>
				<div className='home-div-title'>{company.companyName}</div>
				<div className='home-div-title'>{company.address}</div>
				{equipmentList.length > 0 && equipmentList.map((item, index) => {
					return (
						<div key={index} className='home-div'>
							<div className='home-div-left'>
								{
									item.equipmentType == 1 && <img src={require('../../common/images/yy.png')} alt='home-icon' />
									||
									item.equipmentType == 2 && <img src={require('../../common/images/fj.png')} alt='home-icon' />
								}
								<div className='home-div-left'>
									<div className='home-div-left-title'>
										<div className='home-div-left-title-icon'>{item.equipmentName}</div>
										<div className='home-div-left-title-text'>
											{/* <img src="https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg" alt='home-icon' /> */}
											<WifiOutlined />
												{
													item.equipmentType == 1 && (
														item.equipmentStaus == 0 &&
														<div className='yunxing'>运行中</div>
														||
														item.equipmentStaus == 1 &&
														<div className='chaobiao'>超标报警</div>
														||
														item.equipmentStaus == 2 &&
														<div className='chaobiao'>无信号</div>
													)
													||
													item.equipmentType == 2 && (
														item.equipmentStaus == 1 &&
														<div className='yunxing'>运行中</div>
														||
														item.equipmentStaus == 0 &&
														<div className='chaobiao'>无信号</div>
														||
														item.equipmentStaus == 2 &&
														<div className='chaobiao'>无信号</div>
													)
												}
										</div>
									</div>

									<div className='home-div-left-content'>使用时间:<span className='title'>{item.nextTime}h/</span>{item.equipmentUpkeepTime}h</div>

								</div>
							</div>
							{
								item.equipmentUpkeepTime - item.nextTime < 100 && <div className='home-div-right'>温馨提示:保养时间已到，请尽快保养</div>
								||
								
								<div className='home-div-right-ok'>
										{
											item.equipmentType == 1 && (
												item.equipmentStaus == 0 &&
												<div className='yunxing'>温馨提示:设备运行正常</div>
												||
												item.equipmentStaus == 1 &&
												<div className='chaobiao'> 温馨提示 :超标报警</div>
												||
												item.equipmentStaus == 2 &&
												<div className='chaobiao'> 温馨提示 :断电停机(请联系店铺管理员通电)</div>
											)
											||
											item.equipmentType == 2 && (
												item.equipmentStaus == 1 &&
												<div className='yunxing'>温馨提示:设备运行正常</div>
												||
												item.equipmentStaus == 0 &&
												<div className='chaobiao'> 温馨提示 :停机了(请联系店铺管理员通电)</div>
												||
												item.equipmentStaus == 2 &&
												<div className='chaobiao'> 温馨提示 :断电停机(请联系店铺管理员通电)</div>
											)
										}
								</div>
							}
						</div>

					)
				})}
				{
					equipmentList.length === 0 && <div className='home-div'>暂无绑定店铺信息，请联系管理员绑定店铺</div>
				}
				{/* <div className='home-div'>
					<div className='home-div-left'>
						<img src="https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg" alt='home-icon' />
						<div className='home-div-left'>
							<div className='home-div-left-title'>
								<div className='home-div-left-title-icon'>风机</div>
								<div className='home-div-left-title-text'>
									<img src="https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg" alt='home-icon' />
									<div className='yunxing'>正在运行</div>
								</div>
							</div>

							<div className='home-div-left-content'>使用时间:4000h/5000h</div>

						</div>
					</div>
					<div className='home-div-right'>温馨提示:保养时间已到，请尽快保养</div>
				</div> */}

				{/* <div className='home-div' onClick={() => props.history.push('/devices')}>我的设备</div> */}
				{/* <div className='home-div' onClick={() => props.history.push('/shops')}>店铺及设备信息</div>
				<div className='home-div' onClick={() => props.history.push('/upkeeplist')}>设备保养记录 </div> */}
			</section>
		</Page>
	);
};

export default PageModel;
